




































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { InspectCommentItem } from "@/models/InspectCommentItem";
import { InspectCommentService } from "@/services/InspectComment.service";
import { MESSAGE } from "@/models/Message";
import Pagination from "@/views/components/Pagination.vue";

@Component({
  components: {
    Pagination
  }
})
export default class InspectComment extends Vue {
  @Prop({ default: "" })
  title: string;
  loading: boolean = false;
  inspectComments: InspectCommentItem[] = [];
  inspectCommentsPage: InspectCommentItem[] = [];
  inspectCommentService: InspectCommentService = new InspectCommentService();
  dialogFormVisible: boolean = false;
  disableBtnEdit: boolean = false;
  dataEditing: InspectCommentItem = {} as InspectCommentItem;
  dialogImgVisible: boolean = false;
  imageUrl: string = "";
  images: any = [];
  uploadURl: string = "";
  msgNodata: string = MESSAGE.NoData;
  loadingImg: boolean = false;
     itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
   itemSizeSelected: number = 10;

  created() {
    this.getData();
  }

  async getData() {
    this.loading = true;
    const response = await this.inspectCommentService.getInspectComment();
    if (response) {
      this.inspectComments = response.reverse();
    }
    this.loading = false;
  }

  async onSubmitEdit() {
    this.dialogFormVisible = false;
    const response = await this.inspectCommentService.editInspectComment(
      this.dataEditing
    );
    if (response) {
      this.getData();
    }
  }

  showEditDialog(item: InspectCommentItem) {
    this.dataEditing = { ...item };
    this.dialogFormVisible = true;
  }

  showImgDialog(item: InspectCommentItem) {
    this.dataEditing = { ...item };
    this.images = [];
    this.loadingImg = true;
    this.dialogImgVisible = true;
    this.uploadURl = this.inspectCommentService.getUploadURL(item.id);
    this.getImages(item.id);
  }

  async getImages(commentId: number) {
    const response = await this.inspectCommentService.getInspectImage(
      commentId
    );
    this.loadingImg = false;
    if (response) {
      this.images = response;
    }
  }

  beforeUpload(file: any) {
    if (file.type.indexOf("image") == -1) {
      this.$message.error("This file is not image!");
    } else if (file.size / 1024 / 1024 > 1) {
      this.$message.error("Image size exceed 1MB!");
    } else {
      this.inspectCommentService
        .uploadImage(file, this.dataEditing.id)
        .then((res: any) => {
          if (res == 200) {
            this.getImages(this.dataEditing.id);
          } else {
            this.$message.error(MESSAGE.SystemError);
          }
        });
    }
    return false;
  }

  async onDeleteImg(id: number, index: number) {
    const response = await this.inspectCommentService.deleteImage(id);
    if (response == 200) {
      this.images.splice(index, 1);
    } else {
      this.$message.error(MESSAGE.SystemError);
    }
  }
}
